'use strict';

function EmailController($rootScope, $scope, objectMakerFactory, dataHolderFactory, dataRequestService, usSpinnerService) {
	$scope.initEmailController = function() {
		$scope.emailViewControl = objectMakerFactory.viewObjectControlForEmail();
		$scope.emailViewControl.attachment = dataHolderFactory.getPdfDataUri();
	};

	$scope.restoreViewControl = function() {
		dataHolderFactory.updatePdfDataUri('');
		$rootScope.appControl.showEmailBox = false;
	};

	$scope.send = function() {
		usSpinnerService.spin('spinner-1');
		dataRequestService.sendEmail($scope.emailViewControl).then(function() {
			usSpinnerService.stop('spinner-1');
			$scope.restoreViewControl();
		}, function(error) {
			usSpinnerService.stop('spinner-1');
			alert(error.data.error);
		});
	};
}
EmailController.$inject = ['$rootScope', '$scope', 'objectMakerFactory', 'dataHolderFactory', 'dataRequestService', 'usSpinnerService']
export default EmailController


// WEBPACK FOOTER //
// ./src/app/scripts/controllers/emailController.js